import { Icon } from "@repo/ui/components/icon";
import { ShortcutKbd } from "@repo/ui/lib/actions/shortcut-kbd";
import { Button } from "@repo/ui/ui/button";
import { Tooltip, TooltipContent, TooltipTrigger } from "@repo/ui/ui/tooltip";

import { createDataset } from "~/stores/datasets/datasets.actions";
import { createNamedDatasetFolder } from "./datasets.store";

/**
 * Create actions for the datasets browse page, rendered by `TopBar` alongside
 * the other route-scoped header controls so they sit next to the AI toggle
 * instead of competing with the list header.
 */
export const DatasetsHeaderActions = () => (
  <>
    <Tooltip>
      <TooltipTrigger
        render={
          <Button
            variant="ghost"
            size="icon-sm"
            aria-label="New folder"
            onClick={createNamedDatasetFolder}
          />
        }
      >
        <Icon name="folder" />
      </TooltipTrigger>
      <TooltipContent className="flex items-center gap-2">
        New folder
        <ShortcutKbd shortcutId="new-dataset-folder" />
      </TooltipContent>
    </Tooltip>
    <Tooltip>
      <TooltipTrigger
        render={
          <Button
            variant="ghost"
            size="icon-sm"
            aria-label="New dataset"
            onClick={createDataset}
          />
        }
      >
        <Icon name="dataset-plus" />
      </TooltipTrigger>
      <TooltipContent className="flex items-center gap-2">
        New dataset
        <ShortcutKbd shortcutId="new-dataset" />
      </TooltipContent>
    </Tooltip>
  </>
);
